// removed by extract-text-webpack-plugin
module.exports = {"image":"style__image___1bS8S","container_memorial":"style__container_memorial___2OUtS","container":"style__container___24344","img":"style__img___vfzKA","imgBg":"style__imgBg___1IzgH","loader":"style__loader___2tN9G","fullscreenImgContainer":"style__fullscreenImgContainer___3R-Zq","fullscreenImg":"style__fullscreenImg___1asyR","fullscreenImgBg":"style__fullscreenImgBg___3JQUV","fullscreenCloseBtn":"style__fullscreenCloseBtn___3vKCV","fullscreenCloseBtn_memorial":"style__fullscreenCloseBtn_memorial___UhzAx"};


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/stickers/ui/components/media-photo/style.css
// module id = 1246
// module chunks = 0